import { render } from "./ProceedingView.vue?vue&type=template&id=1197104d&scoped=true"
import script from "./ProceedingView.vue?vue&type=script&lang=js"
export * from "./ProceedingView.vue?vue&type=script&lang=js"

import "./ProceedingView.vue?vue&type=style&index=0&id=1197104d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1197104d"]])

export default __exports__